export default {"src":"/_next/static/media/checkbox.4674c752.svg","height":35,"width":34,"blurWidth":0,"blurHeight":0};